import React, { useEffect, useState } from 'react';
import { IconButton, List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
import { ClipTextField } from './TextField';
import { Assignment } from '@material-ui/icons';
import UserContext from '../context/userContext';
import { toast } from 'react-toastify';

const useStyles = makeStyles((theme) =>({

    copy : {
        borderRadius: 'none',
        gridArea : 'copyIcon',
        width: 'fit-content',
        justifySelf: 'flex-end',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'black',
            color : '#fe752f',
            border : 'none',
            borderRadius : '50%',
        },
    }
    
}));





const BottomMainDeck = function BottomMainDeck(){
    
    const classes = useStyles();
    const [txtVal, setTxtVal] = useState("");
    const [from, setFrom] = useState("text");
    var { teleport, webShare, setWs } = React.useContext(UserContext);

    var sendTextContent = (text) => {
        teleport.sendTextData(text);
    }

    var readClip = async () => {
        let text;
        if (navigator.clipboard) {
            text = await navigator.clipboard.readText();
            setTxtVal(text);
            sendTextContent(text);
            toast.info("Shared clipboard contents",{
                toastId : "Sent clipboard contents",
            });
        }
    }

    useEffect(() => {
        if(webShare && typeof(webShare) === 'string') {
            setWs(null);
            webShare = null;
            setFrom("copy");
            readClip();
        }
    }, [])


    return(
        <div className='bottomMainDeck' >
            <ClipTextField from={from} handleFrom={(txt)=>{ setFrom(txt) }} text={txtVal} handleClipText={(txt)=>{ setTxtVal(txt); }} handleSendText={()=>{ 
                toast.info("Shared text content!",{
                    toastId : "007",
                });
                sendTextContent(txtVal)
                 }} 
            />
            <IconButton id="Clipbtn" onClick={()=>{ setFrom("copy"); readClip(); }} classes={{ root: classes.copy }} >
                <Assignment />
            </IconButton>
            <p className="copyText" >Read from clipboard</p>
        </div>
    )
    
}

export default BottomMainDeck;